(() => {
 'use strict';
 const openRecovery=()=>{if(location.hash==='#recover'){const recovery=document.getElementById('recover');if(recovery){recovery.open=true;recovery.querySelector('input[type="email"]')?.focus({preventScroll:true})}}};
 openRecovery();window.addEventListener('hashchange',openRecovery);
 const dialogs = [...document.querySelectorAll('.utility-dialog')];
 const triggers = [...document.querySelectorAll('[data-open-utility]')];
 const cards = [...document.querySelectorAll('[data-saved-style]')];
 const favoriteDialog = document.getElementById('ynd-favorites-dialog');
 const list = document.querySelector('[data-favorites-list]');
 const empty = document.querySelector('[data-favorites-empty]');
 const note = document.getElementById('ynd-favorites-note');
 const status = document.getElementById('ynd-save-status');
 const closeIcon = favoriteDialog.querySelector('[data-close-utility] svg');
 const key = 'ynd.saved-editorial-styles.v1';
 let products = [];
 try { products = JSON.parse(document.getElementById('ynd-saved-catalog')?.textContent || '[]'); } catch {}
 const catalog = new Map(products.map(product => [product.id, product]));
 cards.forEach(card => {
  const id=card.dataset.savedStyle;
  if(catalog.has(id)) catalog.get(id).button=card.querySelector('[data-save-style]');
 });
 const allowed = new Set(catalog.keys());
 let saved = new Set();
 let persistent = true;
 try {
  const previous = JSON.parse(localStorage.getItem(key) || '[]');
  if (Array.isArray(previous)) saved = new Set(previous.filter(id => allowed.has(id)));
 } catch { persistent = false; }
 const announce = text => { status.textContent = text; };
 function writeSaved() {
  try { localStorage.setItem(key, JSON.stringify([...saved])); }
  catch { persistent = false; }
  note.textContent = persistent
   ? 'Saved in this browser only. They won’t sync with your account or other devices.'
   : 'Browser storage is unavailable. Saved styles will last only while this page is open.';
 }
 function updateButtons() {
  catalog.forEach((style, id) => {
   style.button?.setAttribute('aria-pressed', String(saved.has(id)));
   style.button?.setAttribute('aria-label', `${saved.has(id) ? 'Unsave' : 'Save'} ${style.title}`);
   if (style.button) style.button.title = saved.has(id) ? 'Remove saved style' : 'Save style';
  });
  document.querySelectorAll('[data-favorite-count]').forEach(count => {
   count.textContent = String(saved.size); count.hidden = saved.size === 0;
  });
 }
 function renderSaved() {
  list.replaceChildren();
  empty.hidden = saved.size > 0;
  saved.forEach(id => {
   const style = catalog.get(id);
   if (!style) return;
   const row = document.createElement('article'); row.className = 'saved-style-row';
   const image = document.createElement('img'); image.src = style.image; image.alt = style.alt; image.width = 76; image.height = 96;
   const copy = document.createElement('div');
   const title = document.createElement('h3');
   const link = document.createElement('a'); link.textContent=style.title; link.href=style.url; title.append(link);
   const detail = document.createElement('p'); detail.textContent = style.held ? 'Style preview · availability to be confirmed' : 'Saved from the YND wardrobe';
   copy.append(title, detail);
   const remove = document.createElement('button'); remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${style.title}`); remove.append(closeIcon.cloneNode(true));
   remove.addEventListener('click', () => {
    saved.delete(id); writeSaved(); updateButtons(); renderSaved(); announce(`${style.title} removed from saved styles.`);
    (list.querySelector('button') || favoriteDialog.querySelector('[data-browse-styles]')).focus();
   });
   row.append(image, copy, remove); list.append(row);
  });
 }
 cards.forEach(card => {
  const id = card.dataset.savedStyle;
  card.querySelector('[data-save-style]').addEventListener('click', () => {
   if (saved.has(id)) saved.delete(id); else saved.add(id);
   writeSaved(); updateButtons(); renderSaved();
   announce(`${catalog.get(id).title} ${saved.has(id) ? 'saved in this browser' : 'removed from saved styles'}.`);
  });
 });
 const openers = new Map();
 const notifyOverlay = () => document.dispatchEvent(new Event('ynd:overlay'));
 triggers.forEach(trigger => trigger.addEventListener('click', event => {
  const dialog = document.getElementById(trigger.dataset.openUtility);
  if (!dialog || typeof dialog.showModal !== 'function') return;
  event.preventDefault();
  openers.set(dialog, trigger);
  if (dialog === favoriteDialog) renderSaved();
  dialog.showModal();
  notifyOverlay();
  (dialog.querySelector('input:not([type="hidden"])') || dialog.querySelector('[data-close-utility]')).focus({ preventScroll: true });
 }));
 dialogs.forEach(dialog => {
  dialog.querySelector('[data-close-utility]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
   if (event.target !== dialog) return;
   const box = dialog.getBoundingClientRect();
   if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { notifyOverlay(); openers.get(dialog)?.focus({ preventScroll: true }); });
 });
 favoriteDialog.querySelector('[data-browse-styles]').addEventListener('click', () => favoriteDialog.close());
 window.addEventListener('storage', event => {
  if (event.key !== key) return;
  try {
   const value = JSON.parse(event.newValue || '[]');
   saved = new Set(Array.isArray(value) ? value.filter(id => allowed.has(id)) : []);
   updateButtons(); renderSaved();
  } catch { /* Ignore malformed external storage without changing this page's selections. */ }
 });
 updateButtons(); renderSaved();
 if (!persistent) note.textContent = 'Browser storage is unavailable. Saved styles will last only while this page is open.';
})();
